import React from "react";
import { I18n } from "react-redux-i18n";
import cx from "classnames";

import { Loading } from "@common/components/loading";
import Tree, { TreeGetIdArgs } from "@common/components/Tree";
import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";
import { getTestAttributes } from "@common/utils/tests";

import "./folders.styles.scss";

type FoldersProps = {
  selectedFolder?: FolderPrimaryListDto;
  folders: Array<FolderPrimaryListDto>;
  loading: boolean;
  onSelectedFolderChange: (folder: FolderPrimaryListDto) => void;
  className?: string;
  moduleName: string;
};

export const Folders = (props: FoldersProps) => {
  const { folders, selectedFolder, loading, onSelectedFolderChange, className, moduleName } = props;

  return (
    <div className={cx("FormatFieldSelectorFolders", className)}>
      {loading && <Loading size={20} margin="20px" />}
      {!loading && !folders.length && (
        <div className="FormatFieldSelectorFolders__no-data-message">{I18n.t("No folders")}</div>
      )}
      {!loading && folders.length > 0 && (
        <Tree
          getId={{
            folder: ({ parentIndex, ownIndex, data }: TreeGetIdArgs) =>
            parentIndex === undefined
              ? getTestAttributes(moduleName, "format-field-selector-folders", ownIndex).id
              : getTestAttributes(moduleName, "format-field-selector-folders-child", data.id).id,
          collapseIcon: ({ parentIndex, ownIndex }: TreeGetIdArgs) =>
            parentIndex === undefined
              ? getTestAttributes(moduleName, `format-field-selector-folders-${ownIndex}-exp-icon`).id
              : getTestAttributes(moduleName, `format-field-selector-folders-child-${ownIndex}-exp-icon`).id,
          }}
          items={folders}
          value={selectedFolder?.id}
          onChange={(id: FolderPrimaryListDto["id"], folder: FolderPrimaryListDto) => onSelectedFolderChange(folder)}
          defaultCollapsed={false}
          shouldDisableItem={(item: FolderPrimaryListDto) => item.system === true}
        />
      )}
    </div>
  );
};
